export const TD = {
  nav: "nav-database-designer",
  page: "table-designer-page",
  environment: "table-designer-environment",
  moduleTables: "table-designer-module-tables",
  moduleRelationships: "table-designer-module-relationships",
  moduleQueries: "table-designer-module-queries",
  moduleForms: "table-designer-module-forms",
  moduleReports: "table-designer-module-reports",
  moduleApplication: "table-designer-module-application",
  tableSearch: "table-designer-table-search",
  tableList: "table-designer-table-list",
  tableItem: "table-designer-table-item",
  newTableBtn: "table-designer-new-table",
  newTableName: "table-designer-new-table-name",
  newTableDescription: "table-designer-new-table-description",
  newTableCreate: "table-designer-new-table-create",
  title: "table-designer-title",
  tableName: "table-designer-table-name",
  tableDescription: "table-designer-table-description",
  previewDataBtn: "table-designer-preview-data",
  saveTableBtn: "table-designer-save-table",
  designViewBtn: "table-designer-design-view",
  datasheetViewBtn: "table-designer-datasheet-view",
  fieldGrid: "table-designer-field-grid",
  fieldSearch: "table-designer-field-search",
  unsaved: "table-designer-unsaved",
  validation: "table-designer-validation",
  addFieldBtn: "table-designer-add-field",
  duplicateFieldBtn: "table-designer-duplicate-field",
  deleteFieldBtn: "table-designer-delete-field",
  moveUpBtn: "table-designer-move-up",
  moveDownBtn: "table-designer-move-down",
  fieldProps: "table-designer-field-props",
  fieldPropsGeneral: "table-designer-field-props-general",
  fieldPropsLookup: "table-designer-field-props-lookup",
  fieldPropsAdvanced: "table-designer-field-props-advanced",
  propName: "table-designer-prop-name",
  propDataType: "table-designer-prop-data-type",
  propRequired: "table-designer-prop-required",
  propPrimaryKey: "table-designer-prop-primary-key",
  propUnique: "table-designer-prop-unique",
  propIndexed: "table-designer-prop-indexed",
  propDefault: "table-designer-prop-default",
  propDescription: "table-designer-prop-description",
  propLength: "table-designer-prop-length",
  propPrecision: "table-designer-prop-precision",
  propScale: "table-designer-prop-scale",
  propLookupKind: "table-designer-prop-lookup-kind",
  propLookupOptions: "table-designer-prop-lookup-options",
  propLookupTable: "table-designer-prop-lookup-table",
  propLookupColumn: "table-designer-prop-lookup-column",
  propLookupDisplay: "table-designer-prop-lookup-display",
  propForeignKey: "table-designer-prop-foreign-key",
  advancedToggle: "table-designer-advanced-toggle",
  previewSql: "table-designer-preview-sql",
  datasheet: "table-designer-datasheet",
  datasheetSearch: "table-designer-datasheet-search",
  datasheetColumns: "table-designer-datasheet-columns",
  datasheetTechnicalGroup: "table-designer-datasheet-technical-group",
  datasheetCount: "table-designer-datasheet-count",
  datasheetPrev: "table-designer-datasheet-prev",
  datasheetNext: "table-designer-datasheet-next",
  sheetHead: "table-designer-sheet-head",
  sheetRow: "table-designer-sheet-row",
  sheetCell: "table-designer-sheet-cell",
  newRecordBtn: "table-designer-new-record",
  placeholder: "table-designer-placeholder",
};
// Form Designer ids live in constants/testIds/formDesigner.js (FD).
